import { OpportunityStatus, OpportunityType } from '../../../models/opportunity.model';

export const STATUS_COLOR: Record<OpportunityStatus, string> = {
  [OpportunityStatus.None]: 'materialGray',
  [OpportunityStatus.Draft]: 'materialGray',
  [OpportunityStatus.Proposed]: 'materialGray',
  [OpportunityStatus.Bid]: 'sopraOrange',
  [OpportunityStatus.Live]: 'sopraGreen',
  [OpportunityStatus.Archived]: 'sopraPrimary',
};

export const STATUS_LABEL: Record<OpportunityStatus, string> = {
  [OpportunityStatus.None]: 'Unknown',
  [OpportunityStatus.Draft]: 'Draft',
  [OpportunityStatus.Proposed]: 'Proposed',
  [OpportunityStatus.Bid]: 'Bid',
  [OpportunityStatus.Live]: 'Live',
  [OpportunityStatus.Archived]: 'Archived',
};

export const TYPE_LABEL: Record<OpportunityType, string> = {
  [OpportunityType.None]: '—',
  [OpportunityType.FullTime]: 'Full-Time',
  [OpportunityType.PartTime]: 'Part-Time',
  [OpportunityType.StretchProject]: 'Stretch Project',
  [OpportunityType.Mentorship]: 'Mentorship',
  [OpportunityType.JobShadow]: 'Job Shadow',
};

export const TYPE_OPTIONS = [
  { value: String(OpportunityType.FullTime), label: 'Full-Time' },
  { value: String(OpportunityType.PartTime), label: 'Part-Time' },
  { value: String(OpportunityType.StretchProject), label: 'Stretch Project' },
  { value: String(OpportunityType.Mentorship), label: 'Mentorship' },
  { value: String(OpportunityType.JobShadow), label: 'Job Shadow' },
];

export const STATUS_OPTIONS = [
  { value: String(OpportunityStatus.Draft), label: 'Draft' },
  { value: String(OpportunityStatus.Proposed), label: 'Proposed' },
  { value: String(OpportunityStatus.Bid), label: 'Bid' },
  { value: String(OpportunityStatus.Live), label: 'Live' },
];

export const TYPE_ACCENT: Record<OpportunityType, string> = {
  [OpportunityType.None]: 'var(--mantine-color-materialGray-5)',
  [OpportunityType.FullTime]: 'var(--mantine-color-sopraBlue-5)',
  [OpportunityType.PartTime]: 'var(--mantine-color-sopraGreen-5)',
  [OpportunityType.StretchProject]: 'var(--mantine-color-sopraOrange-5)',
  [OpportunityType.Mentorship]: 'var(--mantine-color-sopraPurple-5)',
  [OpportunityType.JobShadow]: 'var(--mantine-color-materialGray-5)',
};
